import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function AccountFilters({
  nameFilter,
  setNameFilter,
  emailFilter,
  setEmailFilter,
}) {
  const [t] = useTranslation();
  const [nameInput, setNameInput] = useState(nameFilter);
  const [emailInput, setEmailInput] = useState(emailFilter);
  const nameTimeoutRef = useRef(null);
  const emailTimeoutRef = useRef(null);

  useEffect(() => {
    setNameInput(nameFilter);
  }, [nameFilter]);

  useEffect(() => {
    setEmailInput(emailFilter);
  }, [emailFilter]);

  // Debounce name filter
  useEffect(() => {
    if (nameTimeoutRef.current) {
      clearTimeout(nameTimeoutRef.current);
    }

    nameTimeoutRef.current = setTimeout(() => {
      setNameFilter(nameInput || "");
    }, 600);

    return () => {
      if (nameTimeoutRef.current) {
        clearTimeout(nameTimeoutRef.current);
      }
    };
  }, [nameInput, setNameFilter]);

  // Debounce email filter
  useEffect(() => {
    if (emailTimeoutRef.current) {
      clearTimeout(emailTimeoutRef.current);
    }

    emailTimeoutRef.current = setTimeout(() => {
      setEmailFilter(emailInput || "");
    }, 600);

    return () => {
      if (emailTimeoutRef.current) {
        clearTimeout(emailTimeoutRef.current);
      }
    };
  }, [emailInput, setEmailFilter]);

  return (
    <div className="mb-4 flex gap-4">
      <div className="flex flex-col group relative w-64">
        <input
          value={nameInput}
          onChange={(e) => setNameInput(e.target.value)}
          className="block w-full rounded-md border-gray-300 px-3 py-2 pr-12 shadow-sm disabled:bg-slate-200 text-sm peer"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (nameTimeoutRef.current) {
                clearTimeout(nameTimeoutRef.current);
              }
              setNameFilter(nameInput || "");
            }
          }}
        />
        <label
          className="text-sm top-2 mx-3 absolute transition-all delay-100 cursor-text
            group-focus-within:-top-5 group-focus-within:text-xs group-focus-within:mx-0
            peer-valid:-top-5 peer-valid:text-xs peer-valid:mx-0"
        >
          {t("signup.name") || t("signup.iin")}
        </label>
        <div className="absolute right-2 bottom-2.5 cursor-pointer text-primary">
          <MagnifyingGlassIcon
            className="h-5"
            onClick={() => {
              if (nameTimeoutRef.current) {
                clearTimeout(nameTimeoutRef.current);
              }
              setNameFilter(nameInput || "");
            }}
          />
        </div>
      </div>
      <div className="flex flex-col group relative w-64">
        <input
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          className="block w-full rounded-md border-gray-300 px-3 py-2 pr-12 shadow-sm disabled:bg-slate-200 text-sm peer"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (emailTimeoutRef.current) {
                clearTimeout(emailTimeoutRef.current);
              }
              setEmailFilter(emailInput || "");
            }
          }}
        />
        <label
          className="text-sm top-2 mx-3 absolute transition-all delay-100 cursor-text
            group-focus-within:-top-5 group-focus-within:text-xs group-focus-within:mx-0
            peer-valid:-top-5 peer-valid:text-xs peer-valid:mx-0"
        >
          {t("student.email")}
        </label>
        <div className="absolute right-2 bottom-2.5 cursor-pointer text-primary">
          <MagnifyingGlassIcon
            className="h-5"
            onClick={() => {
              if (emailTimeoutRef.current) {
                clearTimeout(emailTimeoutRef.current);
              }
              setEmailFilter(emailInput || "");
            }}
          />
        </div>
      </div>
    </div>
  );
}
